import { render, staticRenderFns } from "./DeliveryDayField.vue?vue&type=template&id=4e370b5a&"
import script from "./DeliveryDayField.vue?vue&type=script&lang=js&"
export * from "./DeliveryDayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports